import EventHandler from '../eventSystem/EventHandler'
import SystemRegistry from '../systemRegistry'

export default class ConsoleSystem {

    static getInstance() {
        if (!this.instance) {
            this.instance = new ConsoleSystem()
            SystemRegistry.gI().registerConsole(this.instance)

        }
        return this.instance
    }

    static gI() {
        return this.getInstance()
    }

    addConsoleMessage(message) {
        if(message.includes("Please turn on your Arduino Alvik")){
            EventHandler.gI().triggerEvent({
                type: "ERROR",
                message: "Bitte schalte dein Arduino Alvik ein!",
                triggerToast: true
            })
        }
        console.log(`Console message: ${message}`)
    }
}